import type { ReactNode } from "react";
import styles from "./ds.module.css";

export function EmptyState({ title, body, action }: { title: ReactNode; body?: ReactNode; action?: ReactNode }) {
    return (
        <div className={styles.empty}>
            <div className={styles.emptyTitle}>{title}</div>
            {body && <div className={styles.emptyBody}>{body}</div>}
            {action && <div className={styles.emptyAction}>{action}</div>}
        </div>
    );
}
